import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CONVERSATIONAL_FEATURE_SELECTOR } from '../constants';
import { ConversationalState } from '../interfaces/conversational-state.interface';
import { ContextItem, ExchangeItem } from './conversational.models';

// conversation state
const selectConversationalState = createFeatureSelector<ConversationalState>(CONVERSATIONAL_FEATURE_SELECTOR);
const selectAllContexts = createSelector(selectConversationalState, (state: ConversationalState) => state.contexts);
const selectConversationalStateLoading = createSelector(selectConversationalState, (state: ConversationalState) => state.loading);
const selectConversationalStateError = createSelector(selectConversationalState, (state: ConversationalState) => state.error);

// Select the current context
const selectActiveContext = createSelector(
  selectConversationalState,
  (state: ConversationalState) => state.contexts[state.activeContextId ?? ''] || null
);

const selectListeners = createSelector(selectConversationalState, (state: ConversationalState) => state.listeners || []);

// Select a specific context by its ID
const selectContextById = (contextId: string) => createSelector(selectAllContexts, (contexts) => contexts[contextId]);
const selectContextTitleById = (contextId: string) => createSelector(selectContextById(contextId), (context) => context?.title || '');
const selectContextLoadingById = (contextId: string) =>
  createSelector(selectContextById(contextId), (context: ContextItem) => context?.loading || false);

// Select exchanges for a specific context
const selectExchangesByContextId = (contextId: string) =>
  createSelector(selectContextById(contextId), (context: ContextItem) => context?.exchanges || []);

//
const selectExchangeById = (contextId: string, exchangeId: string) =>
  createSelector(
    selectExchangesByContextId(contextId),
    (exchanges: Array<ExchangeItem>) => exchanges.find((e) => e.id === exchangeId) || null
  );

// Select the error state for a specific context
const selectContextErrorById = (contextId: string) =>
  createSelector(selectContextById(contextId), (context: ContextItem) => context?.error || null);

// External Selectors
const selectActiveRadarUri = createSelector(selectConversationalState, (state: ConversationalState) => state.external.radarCommand);

export const ConversationalSelectors = {
  selectConversationalState,
  selectAllContexts,
  selectConversationalStateLoading,
  selectConversationalStateError,
  selectActiveContext,
  selectListeners,
  selectActiveRadarUri,
  selectContextById,
  selectExchangesByContextId,
  selectExchangeById,
  selectContextTitleById,
  selectContextLoadingById,
  selectContextErrorById
};
